// extracted by mini-css-extract-plugin
export default {"generalStyle":"AttributionsComp_generalStyle__d+rM6"};